import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const ProvidersReports = 'ProviderReports'

export const getProviderReports = (providerId) => {
  return axios.get(`/${ProvidersReports}?providerId=${providerId}`)
}
